import { useState, useRef, useEffect, useCallback } from 'react';

type Category = 'casas' | 'edificios' | 'condominios';

const categories: { id: Category; label: string }[] = [
  { id: 'casas', label: 'Casas' },
  { id: 'edificios', label: 'Edifícios Residenciais' },
  { id: 'condominios', label: 'Condomínios Horizontais' },
];

// 12 imagens por categoria, divididas em 3 seções de 4
const images: Record<Category, { src: string; alt: string }[][]> = {
  casas: [
    // Seção 1
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/fcbca496-d2f3-4286-8149-e42ff2971693_01.jpg?v=f76f5c27a19437a68adabd17bc33edeb',
        alt: 'Casa 01',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/fff3fd27-2cfb-4514-a60f-842ba9df2dcc_02.jpg?v=ef9e810f13de25295aa702c8a7d75e44',
        alt: 'Casa 02',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/f0ea6a89-550c-4239-bca5-d0d57b643535_03.jpg?v=8d5772562c71000a20e3dfdfb915e572',
        alt: 'Casa 03',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/4b4d9c39-c2ad-4642-b60d-7de41806566e_04.jpg?v=53e9444e1e06d6c83f2a90b36fa29a50',
        alt: 'Casa 04',
      },
    ],
    // Seção 2
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/95778235-4ef8-4aeb-8593-e972e7209b33_05.jpg?v=bafb36a271bd7b62d93d6031e9977563',
        alt: 'Casa 05',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/0b273abe-6e09-4461-8509-978b889140ed_06.png?v=45481de347bbf75110df8e043feecac7',
        alt: 'Casa 06',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/0475eab9-43ba-413f-bda0-6779c1855b34_07.jpg?v=1a38d7f0070475bd2dc4268e2e0c4528',
        alt: 'Casa 07',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/52579c0a-cbd2-429b-8158-aa87842e219d_08.png?v=5a67619e63ceae8b5fda9a622c36ac41',
        alt: 'Casa 08',
      },
    ],
    // Seção 3
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/179e2c23-8e2c-48b1-b94f-5b095223a273_09.jpg?v=625178e0b3ea6b274aef829bd302cb90',
        alt: 'Casa 09',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/f3b01798-b10d-4c9c-a42f-e96bc39308b6_10.png?v=d8be20fe473466c2221ce5fbb53e16d8',
        alt: 'Casa 10',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/c94eeea3-d7ff-44bd-b7b8-877af26c7676_11.png?v=413c1c739748c36b9b9756263326d5a5',
        alt: 'Casa 11',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/7f4c714d-86bc-4f79-928c-6b9e686d4e5c_12.png?v=45b8cf68d8bc07e7ebb75d551922f0ba',
        alt: 'Casa 12',
      },
    ],
  ],
  edificios: [
    // Seção 1
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/0929fcb3-7e1e-4df2-bc74-80b5c5713002_01.png?v=af9ee905cfc2db50203ea614e29e4fcb',
        alt: 'Edifício 01',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/d3458de9-b33c-4b7b-8f1b-4381d18a2b3c_02.png?v=3306de7a96a1ffd517746f21b3c7f5b9',
        alt: 'Edifício 02',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/fcaa9479-b2f9-4fc5-8989-9976590d4b8f_03.png?v=4c45f03ed91b660fb9a59ee3fab9cc6a',
        alt: 'Edifício 03',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/cb32e043-4df0-4f89-99f8-e28e99d5dc1d_04.png?v=18ac918e3602f38636d06f3d97581b85',
        alt: 'Edifício 04',
      },
    ],
    // Seção 2
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/627d243b-c50a-4977-9d97-8f6411d0edc8_05.png?v=2930dc8e32af06897ab0ccf897b5b1fe',
        alt: 'Edifício 05',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/0b273abe-6e09-4461-8509-978b889140ed_06.png?v=17772d6b6620cbb461ecb7caf4a98018',
        alt: 'Edifício 06',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/ef15d81b-5acc-468e-9e8c-cbd61e6af652_07.png?v=71e5e30e82af1a5a5b9b66e745ea38cf',
        alt: 'Edifício 07',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/03afae8f-1542-42d8-a8c8-3ad7abe0bc42_08.jpg?v=138d472a750db5d16ebb3d21891026da',
        alt: 'Edifício 08',
      },
    ],
    // Seção 3
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/bbc596c7-ab7e-49db-bb43-4cd8b1a42fb4_09.png?v=b6f9137b916fc9c6b0ddbb3d002e37a2',
        alt: 'Edifício 09',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/8fccca0b-74d8-4773-947b-c1d5cc99e734_10.jpg?v=cf7d667f03cd4cff713fdb5c9847c1e6',
        alt: 'Edifício 10',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/c94eeea3-d7ff-44bd-b7b8-877af26c7676_11.png?v=732f596ec5add1e6245d64b0bd52ce76',
        alt: 'Edifício 11',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/453c0bda-2cde-4c8e-8530-10b7529c9b38_12.jpg?v=74cf1476bb867c9023d6678dfef704e7',
        alt: 'Edifício 12',
      },
    ],
  ],
  condominios: [
    // Seção 1
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/fcbca496-d2f3-4286-8149-e42ff2971693_01.jpg?v=d339730b3cb7a06da07ba25b3a34d63b',
        alt: 'Condomínio Horizontal 01',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/fff3fd27-2cfb-4514-a60f-842ba9df2dcc_02.jpg?v=9241d7d8604c0cb0b5acc8b08f201617',
        alt: 'Condomínio Horizontal 02',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/f0ea6a89-550c-4239-bca5-d0d57b643535_03.jpg?v=1afa8b6c20a5c83a40a36bebbd45532d',
        alt: 'Condomínio Horizontal 03',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/4b4d9c39-c2ad-4642-b60d-7de41806566e_04.jpg?v=2147a72410a18a378033063d6f9bf97d',
        alt: 'Condomínio Horizontal 04',
      },
    ],
    // Seção 2
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/627d243b-c50a-4977-9d97-8f6411d0edc8_05.png?v=fc7f1daff6182a623bd6b189bbcc1323',
        alt: 'Condomínio Horizontal 05',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/c6714ec9-752e-4129-abfd-3b0f0594f307_06.jpg?v=7db803595b0208a8e54e94ff3f06f012',
        alt: 'Condomínio Horizontal 06',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/ef15d81b-5acc-468e-9e8c-cbd61e6af652_07.png?v=4084d61e106c6203a5667e0e0b9b396f',
        alt: 'Condomínio Horizontal 07',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/52579c0a-cbd2-429b-8158-aa87842e219d_08.png?v=3f0592ccdba80637e321bfe084d00f1c',
        alt: 'Condomínio Horizontal 08',
      },
    ],
    // Seção 3
    [
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/bbc596c7-ab7e-49db-bb43-4cd8b1a42fb4_09.png?v=854184743260a0aee68d69dac8ffd455',
        alt: 'Condomínio Horizontal 09',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/f3b01798-b10d-4c9c-a42f-e96bc39308b6_10.png?v=d90e1fdbaa91b32a6e3298f6f46594e4',
        alt: 'Condomínio Horizontal 10',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/c94eeea3-d7ff-44bd-b7b8-877af26c7676_11.png?v=32dc7baf3a2561bdaac5a9911ce5eb8e',
        alt: 'Condomínio Horizontal 11',
      },
      {
        src: 'https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/7f4c714d-86bc-4f79-928c-6b9e686d4e5c_12.png?v=30281a575742396097f39d9c99e33dcc',
        alt: 'Condomínio Horizontal 12',
      },
    ],
  ],
};

const TOTAL_SECTIONS = 3;

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState<Category>('casas');
  const [sectionIndex, setSectionIndex] = useState(0);
  const [lightbox, setLightbox] = useState<string | null>(null);
  const [animating, setAnimating] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const currentSections = images[activeCategory];
  const canPrev = sectionIndex > 0;
  const canNext = sectionIndex < TOTAL_SECTIONS - 1;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('animate-in');
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleCategoryChange = (cat: Category) => {
    if (cat === activeCategory) return;
    setAnimating(true);
    setTimeout(() => {
      setActiveCategory(cat);
      setSectionIndex(0);
      setAnimating(false);
    }, 300);
  };

  const goNext = useCallback(() => {
    if (!canNext || animating) return;
    setAnimating(true);
    setTimeout(() => {
      setSectionIndex((prev) => Math.min(prev + 1, TOTAL_SECTIONS - 1));
      setAnimating(false);
    }, 300);
  }, [canNext, animating]);

  const goPrev = useCallback(() => {
    if (!canPrev || animating) return;
    setAnimating(true);
    setTimeout(() => {
      setSectionIndex((prev) => Math.max(prev - 1, 0));
      setAnimating(false);
    }, 300);
  }, [canPrev, animating]);

  const goToSection = useCallback((idx: number) => {
    if (idx === sectionIndex || animating) return;
    setAnimating(true);
    setTimeout(() => {
      setSectionIndex(idx);
      setAnimating(false);
    }, 300);
  }, [sectionIndex, animating]);

  const visibleImages = currentSections[sectionIndex];

  return (
    <section id="portfolio" ref={sectionRef} className="bg-[#0A0A0A] py-28 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-12 reveal opacity-0 translate-y-8 transition-all duration-700">
          <p className="text-[#A3B18A] font-['Montserrat'] text-xs tracking-[4px] uppercase mb-4">
            Nossos Trabalhos
          </p>
          <h2 className="font-['Montserrat'] font-bold text-3xl md:text-4xl lg:text-[52px] text-white">
            Portfólio
          </h2>
          <div className="w-12 h-[2px] bg-[#A3B18A] mx-auto mt-6" />
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12 reveal opacity-0 translate-y-8 transition-all duration-700 delay-100">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleCategoryChange(cat.id)}
              className={`px-6 py-2.5 rounded-full text-sm font-['Montserrat'] font-medium tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap border ${
                activeCategory === cat.id
                  ? 'bg-[#A3B18A] text-[#0A0A0A] border-[#A3B18A]'
                  : 'bg-transparent text-[#A3B18A] border-[#A3B18A]/40 hover:border-[#A3B18A] hover:text-white'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Carrossel */}
        <div className="reveal opacity-0 translate-y-8 transition-all duration-700 delay-200">
          {/* Grade de 4 imagens */}
          <div
            className={`grid grid-cols-2 lg:grid-cols-4 gap-4 transition-opacity duration-300 ${
              animating ? 'opacity-0' : 'opacity-100'
            }`}
          >
            {visibleImages.map((img, i) => (
              <div
                key={`${activeCategory}-${sectionIndex}-${i}`}
                className="rounded-xl overflow-hidden cursor-pointer group"
                style={{ aspectRatio: '3/4' }}
                onClick={() => setLightbox(img.src)}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            ))}
          </div>

          {/* Controles */}
          <div className="flex items-center justify-center gap-6 mt-10">
            {/* Botão Anterior */}
            <button
              onClick={goPrev}
              disabled={!canPrev}
              className={`w-12 h-12 flex items-center justify-center rounded-full border transition-all duration-300 whitespace-nowrap ${
                canPrev
                  ? 'border-[#A3B18A] text-[#A3B18A] hover:bg-[#A3B18A] hover:text-[#0A0A0A] cursor-pointer'
                  : 'border-[#2F2F2F] text-[#2F2F2F] cursor-not-allowed opacity-40'
              }`}
              aria-label="Seção anterior"
            >
              <i className="ri-arrow-left-line text-lg" />
            </button>

            {/* Indicadores — 3 pontos fixos */}
            <div className="flex gap-3">
              {Array.from({ length: TOTAL_SECTIONS }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => goToSection(i)}
                  className={`h-[3px] rounded-full transition-all duration-300 cursor-pointer ${
                    i === sectionIndex
                      ? 'w-8 bg-[#A3B18A]'
                      : 'w-3 bg-[#2F2F2F] hover:bg-[#A3B18A]/40'
                  }`}
                  aria-label={`Seção ${i + 1}`}
                />
              ))}
            </div>

            {/* Botão Próximo */}
            <button
              onClick={goNext}
              disabled={!canNext}
              className={`w-12 h-12 flex items-center justify-center rounded-full border transition-all duration-300 whitespace-nowrap ${
                canNext
                  ? 'border-[#A3B18A] text-[#A3B18A] hover:bg-[#A3B18A] hover:text-[#0A0A0A] cursor-pointer'
                  : 'border-[#2F2F2F] text-[#2F2F2F] cursor-not-allowed opacity-40'
              }`}
              aria-label="Próxima seção"
            >
              <i className="ri-arrow-right-line text-lg" />
            </button>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-[#0A0A0A]/95 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-white hover:text-[#A3B18A] transition-colors duration-300 cursor-pointer"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-2xl" />
          </button>
          <img
            src={lightbox}
            alt="Portfolio"
            className="max-w-full max-h-[90vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
